/**
 * @type {angular}
 */
module.exports = window.angular;
